import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';
import coffeeImg from './images/coffee-event.png';
import croissantImg from './images/croissant-event.png';
import donutImg from './images/donut-event.png';

interface EventCarouselState {
  step: number;
}

const CAROUSEL_IMAGES = [coffeeImg, croissantImg, donutImg];

export class EventCarousel extends Component<EventCarouselState> {
  private declare cycleInterval: number;
  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        step: 0,
      },
      helpers: {
        CAROUSEL_IMAGES,
        nextStep: () => {
          this.clearInterval();
          this.update({step: (this.state.step + 1) % CAROUSEL_IMAGES.length});
        },
        previousStep: () => {
          this.clearInterval();
          this.update({step: this.state.step === 0 ? CAROUSEL_IMAGES.length - 1 : this.state.step - 1});
        },
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.cycleInterval = window.setInterval(() => {
      this.update({step: (this.state.step + 1) % CAROUSEL_IMAGES.length});
    }, 2000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.clearInterval();
  }

  private clearInterval() {
    clearInterval(this.cycleInterval);
  }
}

export const EventCarouselEl = defineAndMakeJsxFactory(`event-carousel`, EventCarousel);
export const EventCarouselReact = panel2react(`event-carousel`, EventCarousel);
